
define('less/less',['css', 'require'], function(css, require) {
  /**
  *
  * @todo maybe contribute some kind of modification so we dont have to add to the source.
  *
  */
  if(typeof window.preloadCss === "undefined")
    window.preloadCss = $("html").hasClass("preloadCss");

  if(window.preloadCss) {
    return { load: function(n, r, load){ load() } };
  }

  var less = {};
  
  less.pluginBuilder = './less-builder';
  
  if (typeof window == 'undefined') {
    less.load = function(n, r, load) { load(); }
    return less;
  }
  
  //copy api methods from the css plugin
  less.normalize = function(name, normalize) {
    if (name.substr(name.length - 5, 5) == '.less')
      name = name.substr(0, name.length - 5);

    name = normalize(name);

    return name;
  }

  less.parse = function(less, callback) {
    require(['./lessc'], function(lessc) {
      var css;
      var parser = new lessc.Parser();
//	  less = "@basedomain: 'http://www." + window.rootdomain + "/img/tile.svg';\n" + less;
/* @todo inject variables in the less files so we can put absolute urls in and not serve the same images on www.socialpsychology.org as plous.socialpsychology.org */
      parser.parse(less, function(err, tree) {
        if (err) {
          console.log(err)
          throw err;
        }
        try {
          css = tree.toCSS();
        }
        catch(e) {
          throw new Error("LESS parse error: " + e.type + ", " + e.message);
        }
        //instant callback luckily for builds
        callback(css);
      });
    });
  }
  
  less.load = function(lessId, req, load, config) {
    css.load(lessId, req, load, config, less.parse);
  }
  
  return less;
});

define('less', ['less/less'], function (main) { return main; });
